import React, { FunctionComponent, useState } from 'react'
import styles from './SearchCard.module.sass'
import Image from '../files/Image/Image'
import { pipe } from 'fp-ts/function'
import { parseDate, toDateString } from '../../../utils/date-utils'
import Popover from '../../etc/Popover'
import { SearchPreview } from './SearchPreview/SearchPreview'
import { SearchResult } from '../../../responses/search'
import { Link } from 'react-router-dom'
import { urlWithParams } from '../../../http/utils'
import { ROUTES } from '../../../http/routes'
import Color from '../pickers/ColorPicker/Color'
import * as O from 'fp-ts/Option'
import * as A from 'fp-ts/Array'
import Spacer from '../../etc/Spacer'
import { Classes } from '../../../styles'
import clsx from 'clsx'
import EmptyPreview from 'files/empty-preview.svg'
import Ellipsis from '../../etc/Ellipsis/Ellipsis'

interface Props {
    result: SearchResult,
}

const SearchCard: FunctionComponent<Props> = props => {
    const [open, setOpen] = useState(false)

    return <Popover
        isOpen={open}
        positions={['right', 'bottom', 'top', 'left']}
        onClickOutside={() => setOpen(false)}
        content={<SearchPreview result={props.result}/>}
    >

        <Link
            className={styles.card}
            to={urlWithParams({taskId: props.result.id})(ROUTES.TASK)}
            onMouseEnter={() =>setOpen(true)}
            onMouseLeave={() => setOpen(false)}
        >
            {
                pipe(
                    props.result.previews,
                    A.last,
                    O.map(file => <Image key={'image'} className={styles.image} file={file}/>),
                    O.getOrElse(() => <div className={clsx(styles.image, styles.empty)}>
                        <EmptyPreview/>
                    </div>)
                )
            }
            <div className={styles.splitter}/>
            <div className={styles.info}>
                <div className={styles.line}>
                    <Ellipsis className={Classes.f13b}>{props.result.project.name.replace(/^\w\d*_/, '')}</Ellipsis>
                    <Color color={props.result.type.color}>{props.result.type.short_name}</Color>
                </div>
                <Spacer/>
                <div className={styles.line}>
                    <div className={Classes.f13b}>{props.result.project.code}</div>
                </div>
                <div className={clsx(Classes.cGrey, Classes.f11, styles.line)}>
                    <div className={styles.date}>{pipe(props.result.project.opened_at, parseDate, toDateString)}</div>
                    <Ellipsis>{props.result.project_work_object.work_object_type.work_object.name}</Ellipsis>
                </div>
            </div>
        </Link>
    </Popover>
}

export default SearchCard